import * as React from 'react'
import { Loader2Icon } from 'lucide-react'

import { cn } from '@/registry/reapit/lib/utils'

/*
 * Spinner — DS alignment (Phase 3C)
 *
 * No dedicated DS Spinner page, but the principal decisions specify:
 *   - Brand colour: --primary (purple-500 = #4E56EA)
 *   - Sizes aligned to icon scale from plan/04-principal-decisions.md §Dimensions 2:
 *       sm  = size-4  (16px — DS icon-sm)
 *       md  = size-5  (20px — DS icon-md, default)
 *       lg  = size-6  (24px — DS icon-lg)
 *
 * The colour is `text-primary` so the spinner inherits the brand colour.
 * Consumers may override via `className="text-muted-foreground"` etc.
 */

export namespace Spinner {
  export interface Props extends React.ComponentProps<'svg'> {
    /** Icon size variant. Defaults to 'md' (20px = DS icon-md). */
    size?: 'sm' | 'md' | 'lg'
  }
}

const sizeClasses: Record<NonNullable<Spinner.Props['size']>, string> = {
  sm: 'size-4' /* 16px — DS icon-sm */,
  md: 'size-5' /* 20px — DS icon-md */,
  lg: 'size-6' /* 24px — DS icon-lg */,
}

function Spinner({ className, size = 'md', ...props }: Spinner.Props) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn('animate-spin text-primary', sizeClasses[size], className)}
      {...props}
    />
  )
}

export { Spinner }
